import {
    AdministratorState,
    AppState,
    getInitialAdministratorState,
} from '../States/StatesBarrel';

/**
 * This handles initializing the state.
 * @param state
 */
const initializeState = (state: AppState): AppState => {
    const newState: AppState = { ...state };

    if (!newState.administrator) {
        newState.administrator = getInitialAdministratorState();
    } else {
        newState.administrator = { ...newState.administrator };
    }
    return newState;
};

/**
 * Query the state.
 * @param state
 */
const queryAdministratorState = (state: AppState): AdministratorState => {
    return state.administrator;
};

//#region Export initializers
export { initializeState };
//#endregion

//#region Export queries
export { queryAdministratorState };
//#endregion
